export default [
  {
    path: "/manage",
    name: "manage",
    component: () => import("@/views/manage/manageIndex.vue"),
    meta: {
      title: "管理",
    },
  },
];
